<script>
  import options from './GruppeadgangsanmodningList.options'
  export default options
</script>

<template>
  <article v-if="notifications.length > 0" class="kb-gruppeadgangsanmodning-list">
    <div class="kb-gruppeadgangsanmodning-list__header">
      <h2 class="kb-gruppeadgangsanmodning-list__title">{{ getLabel('title') }}</h2>
      <span class="kb-gruppeadgangsanmodning-list__count">{{ notifications.length }} {{ getLabel('resultCountTitle') }}</span>
    </div>
    <ul class="kb-gruppeadgangsanmodning-list__items" aria-label="Notifikationer">
      <li class="kb-gruppeadgangsanmodning-list__items-item" v-for="notification, index in notifications" :key="index">
        <article :aria-labelledby="notification.id" class="kb-gruppeadgangsanmodning-list__items-item-card">
          <div>
            <time class="kb-gruppeadgangsanmodning-list__items-item-date">{{ notification.date }}</time>
            <p class="kb-gruppeadgangsanmodning-list__items-item-text"><strong :id="notification.id">{{ notification.title }}</strong></p>
          </div>
          <div :id="getActionsElementId(notification.id)" class="kb-gruppeadgangsanmodning-list__items-item-actions">
            <button class="kb-link" v-on:click="approveGruppeadgangsanmodning(notification.id)">{{ getLabel('confirmNotificationLabel') }}</button>
            <button class="kb-link" v-on:click="rejectGruppeadgangsanmodning(notification.id)">{{ getLabel('rejectNotificationLabel') }}</button>
          </div>
        </article>
      </li>
    </ul>
  </article>
</template>
